(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"));
	else if(typeof define === 'function' && define.amd)
		define(["react"], factory);
	else if(typeof exports === 'object')
		exports["fui"] = factory(require("react"));
	else
		root["fui"] = factory(root["react"]);
})(this, (__WEBPACK_EXTERNAL_MODULE__39155__) => {
return /******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 3244:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Label: () => (/* reexport */ Badge_Label_Label)
});

// UNUSED EXPORTS: default, labelStyles

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(64922);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(69122);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/styles/variables/_colors.scss
var _colors = __webpack_require__(49144);
;// ./src/components/Badge/Label/label.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const label = ({"label":"src-components-Badge-Label-label_label","isBold":"src-components-Badge-Label-label_isBold"});
;// ./src/components/Badge/Label/Label.tsx




function Label_Label({ className, backgroundColor = _colors/* default */.A.firmColor, textColor = '#fff', fontSize = 12, isBold = false, children, }) {
    const classNames = classnames_default()(label.label, {
        [label.isBold]: isBold,
    }, className);
    if (!fontSize.toString().includes('px')) {
        fontSize += 'px';
    }
    return ((0,jsx_runtime.jsx)("div", { className: classNames, "data-test": "badgeLabel", style: {
            backgroundColor,
            color: textColor,
            fontSize,
        }, children: children }));
}
/* harmony default export */ const Badge_Label_Label = (Label_Label);

;// ./src/components/Badge/Label/index.ts



/* harmony default export */ const Badge_Label = ((/* unused pure expression or super */ null && (Label)));


/***/ }),

/***/ 10905:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var Symbol = __webpack_require__(96711);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),

/***/ 11700:
/***/ ((module) => {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),

/***/ 13394:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var f=__webpack_require__(39155),k=Symbol.for("react.element"),l=Symbol.for("react.fragment"),m=Object.prototype.hasOwnProperty,n=f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,p={key:!0,ref:!0,__self:!0,__source:!0};
function q(c,a,g){var b,d={},e=null,h=null;void 0!==g&&(e=""+g);void 0!==a.key&&(e=""+a.key);void 0!==a.ref&&(h=a.ref);for(b in a)m.call(a,b)&&!p.hasOwnProperty(b)&&(d[b]=a[b]);if(c&&c.defaultProps)for(b in a=c.defaultProps,a)void 0===d[b]&&(d[b]=a[b]);return{$$typeof:k,type:c,key:e,ref:h,props:d,_owner:n.current}}exports.Fragment=l;exports.jsx=q;exports.jsxs=q;


/***/ }),

/***/ 23313:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseGetTag = __webpack_require__(36522),
    isObjectLike = __webpack_require__(52620);

/** `Object#toString` result references. */
var numberTag = '[object Number]';

/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */
function isNumber(value) {
  return typeof value == 'number' ||
    (isObjectLike(value) && baseGetTag(value) == numberTag);
}

module.exports = isNumber;


/***/ }),

/***/ 29107:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var freeGlobal = __webpack_require__(62718);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),

/***/ 36522:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var Symbol = __webpack_require__(96711),
    getRawTag = __webpack_require__(10905),
    objectToString = __webpack_require__(42588);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),

/***/ 39155:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__39155__;

/***/ }),

/***/ 42588:
/***/ ((module) => {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),

/***/ 49144:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"firmColor":"#5d3b84","secondaryColor":"silver","successColor":"#4ab675"});

/***/ }),

/***/ 52620:
/***/ ((module) => {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),

/***/ 54691:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  CountLabel: () => (/* reexport */ Badge_CountLabel_CountLabel)
});

// UNUSED EXPORTS: countLabelStyles, default

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(64922);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(69122);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/components/Badge/Label/index.ts + 2 modules
var Label = __webpack_require__(3244);
;// ./src/components/Badge/CountLabel/countLabel.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const countLabel = ({"animatedPreloader":"src-components-Badge-CountLabel-countLabel_animatedPreloader","countInTab":"src-components-Badge-CountLabel-countLabel_countInTab"});
;// ./src/components/Badge/CountLabel/CountLabel.tsx




const CountLabel_CountLabel = ({ totalCount, canShowCount, showCountWithZeroVolume = true, maxTotalCount = Infinity, className, backgroundColor, fontSize = 10, isBold = true, isFetching = false, }) => {
    if (canShowCount) {
        if (totalCount === 0 && !showCountWithZeroVolume) {
            return (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
        }
        return ((0,jsx_runtime.jsx)(Label.Label, { className: classnames_default()(countLabel.countInTab, className, {
                [countLabel.animatedPreloader]: isFetching,
            }), backgroundColor: backgroundColor, fontSize: fontSize, isBold: isBold, children: totalCount > maxTotalCount ? `${maxTotalCount}+` : totalCount }));
    }
    return (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
/* harmony default export */ const Badge_CountLabel_CountLabel = (CountLabel_CountLabel);

;// ./src/components/Badge/CountLabel/index.ts



/* harmony default export */ const Badge_CountLabel = ((/* unused pure expression or super */ null && (CountLabel)));


/***/ }),

/***/ 62718:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

module.exports = freeGlobal;


/***/ }),

/***/ 64922:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


if (true) {
  module.exports = __webpack_require__(13394);
} else {}


/***/ }),

/***/ 69122:
/***/ ((module, exports) => {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = '';

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (arg) {
				classes = appendClass(classes, parseValue(arg));
			}
		}

		return classes;
	}

	function parseValue (arg) {
		if (typeof arg === 'string' || typeof arg === 'number') {
			return arg;
		}

		if (typeof arg !== 'object') {
			return '';
		}

		if (Array.isArray(arg)) {
			return classNames.apply(null, arg);
		}

		if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
			return arg.toString();
		}

		var classes = '';

		for (var key in arg) {
			if (hasOwn.call(arg, key) && arg[key]) {
				classes = appendClass(classes, key);
			}
		}

		return classes;
	}

	function appendClass (value, newClass) {
		if (!newClass) {
			return value;
		}
	
		if (value) {
			return value + ' ' + newClass;
		}
	
		return value + newClass;
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 96711:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var root = __webpack_require__(29107);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	(() => {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry needs to be wrapped in an IIFE because it needs to be in strict mode.
(() => {
"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Tab: () => (/* reexport */ Tabs_Tabs_Tab),
  TabList: () => (/* reexport */ Tabs_Tabs_TabList),
  TabPanel: () => (/* reexport */ Tabs_Tabs_TabPanel),
  Tabs: () => (/* reexport */ Tabs_Tabs_Tabs),
  "default": () => (/* binding */ Tabs_components_Tabs),
  tabsStyles: () => (/* reexport */ Tabs_tabs)
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var Tabs_jsx_runtime = __webpack_require__(64922);
// EXTERNAL MODULE: external "react"
var Tabs_external_react_ = __webpack_require__(39155);
;// ./src/components/Tabs/TabsContextProvider.tsx


const Tabs_useTabs = ({ defaultTab, onChange, }) => {
    const [selectedTabId, setSelectedTabId] = (0,Tabs_external_react_.useState)(defaultTab);
    (0,Tabs_external_react_.useEffect)(() => {
        setSelectedTabId(defaultTab);
    }, [defaultTab]);
    const select = (tabId) => {
        setSelectedTabId(tabId);
        onChange && onChange(tabId);
    };
    const isSelected = (tabId) => tabId === selectedTabId;
    return {
        selectedTabId,
        select,
        isSelected,
    };
};
const Tabs_TabsContext = (0,Tabs_external_react_.createContext)(null);
const Tabs_useTabsContext = () => (0,Tabs_external_react_.useContext)(Tabs_TabsContext);
const components_Tabs_TabsContextProvider = ({ children, defaultTab, onChange }) => ((0,Tabs_jsx_runtime.jsx)(Tabs_TabsContext.Provider, { value: Tabs_useTabs({ defaultTab, onChange }), children: children }));
/* harmony default export */ const Tabs_Tabs_TabsContextProvider = (components_Tabs_TabsContextProvider);

;// ./src/components/Tabs/Tabs.tsx


const components_Tabs_Tabs = ({ children, defaultTab, onChange, dataTest, className }) => ((0,Tabs_jsx_runtime.jsx)(Tabs_Tabs_TabsContextProvider, { defaultTab: defaultTab, onChange: onChange, children: (0,Tabs_jsx_runtime.jsx)("div", { "data-test": dataTest, className: className, children: children }) }));
/* harmony default export */ const Tabs_Tabs_Tabs = (components_Tabs_Tabs);

;// ./src/components/Tabs/TabList.tsx

const components_Tabs_TabList = ({ children, className, dataTest = 'tabList' }) => ((0,Tabs_jsx_runtime.jsx)("div", { role: "tablist", "data-test": dataTest, className: className, children: children }));
/* harmony default export */ const Tabs_Tabs_TabList = (components_Tabs_TabList);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var Tabs_classnames = __webpack_require__(69122);
var Tabs_classnames_default = /*#__PURE__*/__webpack_require__.n(Tabs_classnames);
// EXTERNAL MODULE: ./node_modules/lodash/noop.js
var Tabs_noop = __webpack_require__(11700);
var Tabs_noop_default = /*#__PURE__*/__webpack_require__.n(Tabs_noop);
// EXTERNAL MODULE: ./node_modules/lodash/isNumber.js
var Tabs_isNumber = __webpack_require__(23313);
var Tabs_isNumber_default = /*#__PURE__*/__webpack_require__.n(Tabs_isNumber);
// EXTERNAL MODULE: ./src/components/Badge/CountLabel/index.ts + 2 modules
var Tabs_CountLabel = __webpack_require__(54691);
// EXTERNAL MODULE: ./src/styles/variables/_colors.scss
var Tabs_colors = __webpack_require__(49144);
;// ./src/components/Tabs/tabs.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const Tabs_tabs = ({"countLabel":"src-components-Tabs-tabs_countLabel"});
;// ./src/components/Tabs/Tab.tsx









const components_Tabs_Tab = ({ tabFor, children, className, activeClassName, disabledClassName, name, selected = false, disabled = false, onClick = (Tabs_noop_default()), focusOnSelect = false, counter, }) => {
    var _a;
    const tabRef = (0,Tabs_external_react_.useRef)(null);
    const context = Tabs_useTabsContext();
    const handleClick = (event) => {
        !disabled && (context === null || context === void 0 ? void 0 : context.select(tabFor));
        onClick(event);
    };
    (0,Tabs_external_react_.useEffect)(() => {
        var _a;
        if (focusOnSelect && (context === null || context === void 0 ? void 0 : context.isSelected(tabFor))) {
            (_a = tabRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
    }, [context === null || context === void 0 ? void 0 : context.selectedTabId]);
    return ((0,Tabs_jsx_runtime.jsxs)("div", { ref: tabRef, role: "tab", className: Tabs_classnames_default()(className, {
            [activeClassName]: (_a = context === null || context === void 0 ? void 0 : context.isSelected(tabFor)) !== null && _a !== void 0 ? _a : selected,
            [disabledClassName]: disabled,
        }), "data-test": name, onClick: handleClick, children: [children, Tabs_isNumber_default()(counter) && ((0,Tabs_jsx_runtime.jsx)(Tabs_CountLabel.CountLabel, { className: Tabs_tabs.countLabel, totalCount: counter, maxTotalCount: 99, canShowCount: true, backgroundColor: Tabs_colors/* default */.A.secondaryColor }))] }));
};
/* harmony default export */ const Tabs_Tabs_Tab = (components_Tabs_Tab);

;// ./src/components/Tabs/TabPanel.tsx


const components_Tabs_TabPanel = ({ tabId, className, dataTest, selected = false, component: Component, children, }) => {
    var _a;
    const context = Tabs_useTabsContext();
    const isSelected = (_a = context === null || context === void 0 ? void 0 : context.isSelected(tabId)) !== null && _a !== void 0 ? _a : selected;
    return ((0,Tabs_jsx_runtime.jsx)("div", { className: className, "data-test": dataTest, id: tabId.toString(), role: "tabpanel", hidden: !isSelected, children: Component ? ((0,Tabs_jsx_runtime.jsx)(Component, { selected: isSelected, children: children })) : children }));
};
/* harmony default export */ const Tabs_Tabs_TabPanel = (components_Tabs_TabPanel);

;// ./src/components/Tabs/index.ts






/* harmony default export */ const Tabs_components_Tabs = (Tabs_Tabs_Tabs);

})();

/******/ 	return __webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=index.js.map